module.exports = __webpack_public_path__ + "img/logo.81b116f9.png";